import { ASSIGNMENT } from '@constants/terminology';

export const NoExplicitUsersNote = ({ className = '' }: { className?: string }) => (
  <div className={`text-ThemeTextLight small ${className}`}>
    <i className='fa-light fa-circle-info me-1' />
    No {ASSIGNMENT.explicit} users
  </div>
);
